import {
  WHITESPACE_REGEX,
  SPACE_CHARACTER,
} from '../const/common';

const TagNames = {
  IMAGE: 'img',
  ANKER: 'a',
  INPUT: 'input',
  TEXTAREA: 'textarea',
  META: 'meta',
};

export const getFollowUpVariableFromElement = (element, variableName) => {
  const skipHrefAnkerTag = !variableName?.toLowerCase().includes('url') && element.className.includes('product-name');
  const tagName = element.tagName.toLowerCase();
  if (tagName === TagNames.IMAGE && (element.src || (element.dataset && element.dataset.src) || (element.dataset && element.dataset.zoom))) {
    let imageSource = element.src || (element.dataset && element.dataset.src) || (element.dataset && element.dataset.zoom);
    if (imageSource?.startsWith('//')) {
      imageSource = `https:${imageSource}`;
    }
    return imageSource;
  }
  if (tagName === TagNames.ANKER && element.href && !skipHrefAnkerTag) {
    return element.href;
  }
  if ((tagName === TagNames.INPUT || tagName === TagNames.TEXTAREA) && element.value) {
    return element.value;
  }
  if ((tagName === TagNames.META) && element.content) {
    return element.content;
  }
  const elementText = element.textContent || element.innerText;
  return elementText.trim().replace(WHITESPACE_REGEX, SPACE_CHARACTER);
};
